var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMaxxiFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_172",
    "data-name": "Raggruppa 172",
    xmlns: "http://www.w3.org/2000/svg",
    width: 388.999,
    height: 64.921,
    viewBox: "0 0 388.999 64.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_175",
    "data-name": "Raggruppa 175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_173",
    "data-name": "Raggruppa 173"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_170",
    "data-name": "Rettangolo 170",
    width: 95.232,
    height: 64.921,
    transform: "translate(95.232 64.921) rotate(-180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_171",
    "data-name": "Rettangolo 171",
    width: 95.012,
    height: 64.921,
    transform: "translate(95.232 0)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_172-2",
    "data-name": "Raggruppa 172",
    transform: "translate(16.723 15.509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_67",
    "data-name": "Tracciato 67",
    d: "M90.264,81.23v.345h-8.1V81.23c1.58,0,1.55-1.14,1.533-1.309L81.209,56.206,71.863,77.7l-1.857,4.278-.761-1.75L58.866,56.258,56.369,79.9c-.077,1.339,1.526,1.328,1.526,1.328v.345H52.326V81.23s2.488-.077,2.67-1.6l2.741-25.975.575-5.415H59.1l.49,1.128L71.1,75.945l9.809-22.554,2.243-5.15H83.8l.166,1.619,3.057,29.106h0s.145,2.263,3.242,2.263Z",
    transform: "translate(-52.326 -47.967)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_68",
    "data-name": "Tracciato 68",
    d: "M209.128,78.954,197,48.7l-.525-1.3h-.449l-1.466,4.115-9.75,27.425c-.516,1.458-2.671,1.723-2.671,1.723v.342h3.026l.01-.1h.008l-.018.1h2.423v-.342s-1.917,0-1.474-1.329H186.1l3.584-10.056h12l4.035,10.056c.5,1.325-1.476,1.329-1.476,1.329v.342H211.8v-.342S209.766,80.411,209.128,78.954Zm-18.953-11.07,5.146-14.464,5.8,14.464Z",
    transform: "translate(-140.649 -47.403)",
    fill: "#1a1818"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_174",
    "data-name": "Raggruppa 174",
    transform: "translate(102.369 15.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_69",
    "data-name": "Tracciato 69",
    d: "M443.051,77.549c-.51-.7-1.051-1.381-1.528-2.106-.863-1.315-1.668-2.67-2.537-3.98-.583-.878-1.239-1.706-1.857-2.559-.721-.994-1.474-1.968-2.135-3a2.013,2.013,0,0,1-.314-1.327,6.838,6.838,0,0,1,.752-1.712c.262-.508.575-.988.863-1.483a12.748,12.748,0,0,1,.738-1.256c.509-.679,1.107-1.289,1.6-1.979.745-1.047,1.488-2.1,2.125-3.22.513-.9,1.477-1.616,1.255-2.864-.012-.065.122-.149.168-.236a5.576,5.576,0,0,0,.516-1.056,1.074,1.074,0,0,0-1.461-1.474c-.047.016-.13-.072-.193-.116-.148-.1-.284-.286-.439-.3a7.1,7.1,0,0,0-1.518-.063,1.6,1.6,0,0,0-.9.4,4.9,4.9,0,0,0-.917,1.2,14.138,14.138,0,0,1-1.1,1.505,12.284,12.284,0,0,0-.83,1.391c-.137.274-.763.687-1.151,1.247-.237.342-.379.761-.631,1.09-.684.894-1.41,1.755-2.111,2.636-.249.313-.474.646-.738,1.007-.821-.724-1.61-1.366-2.333-2.079a8.029,8.029,0,0,1-1.111-1.439c-.866-1.367-1.61-2.826-2.574-4.114a12.879,12.879,0,0,1-1.4-2.257c-.273-.581-.572-1.243-1.344-1.3-.525-.04-.683-.011-1.244-.011a3.867,3.867,0,0,0-1.248.525c-.5.264-.866-.109-1.286-.2a8.167,8.167,0,0,1-.829-.336.765.765,0,0,0-1.024.708c-.119,1.228.84,1.915,1.358,2.817.412.718.935,1.371,1.4,2.058.24.355.447.734.7,1.08.454.624.947,1.219,1.393,1.849.717,1.013,1.389,2.059,2.119,3.062.451.621,1.037,1.145,1.448,1.789a32.269,32.269,0,0,0,1.835,3.133c.779.958.328,1.792.018,2.594-.351.91-1.383,1.358-1.793,2.291a1.1,1.1,0,0,0-.107.618c-.211.365-.438.152-.572.349-.468.69-.98,1.349-1.472,2.023-.3.406-.608.8-.875,1.228-.6.95-1.145,1.93-1.758,2.868-.466.714-1.012,1.372-1.5,2.072a6.814,6.814,0,0,0-.75,1.267,1.992,1.992,0,0,0-.1,1.055c.02.12.439.163.672.25.094.035.174.109.268.142.93.326,1.8.852,2.878.369.5-.225,1.142-.124,1.41-.786.864-.044,1.2-.877,1.653-1.374a17.453,17.453,0,0,0,1.748-2.926,6.213,6.213,0,0,1,1.01-1.526,7.952,7.952,0,0,0,1.775-2.549,1.821,1.821,0,0,1,.438-.475c.248-.228.525-.424.758-.665a4.951,4.951,0,0,0,.436-.581c1.23,1.3,2.444,2.531,3.592,3.822a11.541,11.541,0,0,1,1.48,2.085,15.5,15.5,0,0,0,2.28,3.15c.056.048.074.142.117.209a1.987,1.987,0,0,0,2,1.169c.818-.1,1.642-.161,2.463-.242.38-.037.815-.011.921-.522a3.954,3.954,0,0,1,.57-1.158c.115-.254-.109-.429-.221-.6C443.632,78.327,443.336,77.941,443.051,77.549Z",
    transform: "translate(-385.623 -48.041)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_70",
    "data-name": "Tracciato 70",
    d: "M344.587,75.71c-1.5-2.08-2.978-4.18-4.47-6.268-.761-1.066-1.545-2.117-2.29-3.195a.99.99,0,0,1-.181-.743,6.076,6.076,0,0,1,1.739-2.548l-.018.013a9.54,9.54,0,0,1,.559-1.285c.669-1.088,1.382-2.148,2.079-3.219,1.077-1.655,2.192-3.286,3.218-4.973a2.951,2.951,0,0,0,.553-2.879,1.368,1.368,0,0,0-1.765-.931c-.919.229-.991-1.4-1.812-.93-1.544,1.027-2.343,2.655-3.306,4.067-.121.186-.361.6-.639,1.047-.22.35-.841.606-1.079.924-.752,1-1.323,2.151-1.992,3.224-.3.488-.668.937-1.016,1.394-.249.328-.538.374-.806.028-.8-1.036-1.63-2.055-2.384-3.128-.784-1.115-1.5-2.283-2.235-3.43a18.737,18.737,0,0,1-1.09-1.749,3.775,3.775,0,0,0-2.52-2.219.981.981,0,0,0-1.115.392c-.33.408-.714.66-1.209.417-.444-.218-.83-.558-1.268-.792-.221-.117-.561-.235-.739-.14a1.053,1.053,0,0,0-.453.7,2.965,2.965,0,0,0,.637,2.3,14.489,14.489,0,0,1,.889,1.626c.3.531.6,1.063.941,1.569.251.374.592.684.845,1.058.744,1.1,1.432,2.239,2.2,3.315.609.848,1.368,1.585,1.957,2.445.75,1.095,1.389,2.27,2.093,3.4a2.855,2.855,0,0,1-.244,2.508A16.252,16.252,0,0,0,328,69.616c-1.213,1.747-2.378,3.53-3.532,5.319-.819,1.27-1.6,2.565-2.373,3.865a2.03,2.03,0,0,0-.075,1.768c.173.172.585.107.964.02.257-.059.425.395.675.489a3.941,3.941,0,0,0,.931.122.953.953,0,0,1,.377.057,1.786,1.786,0,0,0,1.726-.11,8.189,8.189,0,0,0,1.841-2.42,27.639,27.639,0,0,1,2.061-3.173c.713-1.026,1.462-2.027,2.211-3.027.349-.467.736-.905,1.12-1.374a2.25,2.25,0,0,1,.281.278,3.012,3.012,0,0,0,1.375,1.416.174.174,0,0,1,.085.085c.71,1.461,1.972,2.472,2.907,3.748a3.578,3.578,0,0,1,.388.76c.293.713.419,1.528,1.223,1.906a.51.51,0,0,1,.244.4c-.1.767.414,1,.951,1.23.494.212.981.444,1.485.63.134.05.316-.053.477-.062a3.015,3.015,0,0,1,.663.009,18.937,18.937,0,0,0,1.938.358c.354.024.906.08.769-.7-.05-.286.229-.534.4-.876a2.023,2.023,0,0,0-.07-1.331C346.256,77.886,345.39,76.822,344.587,75.71Z",
    transform: "translate(-320.315 -48.462)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_71",
    "data-name": "Tracciato 71",
    d: "M525.61,78.591c-.025-1.551-.071-3.1-.122-4.651-.037-1.092-.466-2.156-.112-3.282a5.921,5.921,0,0,0,.135-1.612c.021-.893-.049-1.792.029-2.678.082-.936-.553-1.734-.188-2.792a10.22,10.22,0,0,0,.1-3.217,24.187,24.187,0,0,1-.019-3.142,5.852,5.852,0,0,0-.293-2.976c-.076-.194.049-.479.1-.717.037-.157.16-.3.169-.455.045-.731.022-1.444.043-2.176a2.312,2.312,0,0,0-.025-.257c-.05-.521-1.709-1.221-2.069-.977a.937.937,0,0,1-.58-.019,10.68,10.68,0,0,0-1.855-.113.8.8,0,0,0-.362.025c-.66.249-.86,1.062-.854,1.767.01,1.09-.02,2.182-.066,3.271-.029.7-.156,1.4-.17,2.1-.029,1.4-.024,2.8-.01,4.2.017,1.643.083,3.286.08,4.929,0,1.237-.086,2.473-.116,3.711a1.726,1.726,0,0,0,.135.611,2.981,2.981,0,0,1,.333,2.409,3.575,3.575,0,0,0-.126,1.314c-.005.382.1.77.072,1.149a30.849,30.849,0,0,0-.238,3.116,5.656,5.656,0,0,0,.3,2.282,3.621,3.621,0,0,0,1.318,1.249,3.918,3.918,0,0,0,2.154.214,1.617,1.617,0,0,1,.7-.227,1.174,1.174,0,0,0,1.463-.955A10.979,10.979,0,0,0,525.61,78.591Z",
    transform: "translate(-455.791 -49.037)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_176",
    "data-name": "Raggruppa 176",
    transform: "translate(207.596 17.611)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_72",
    "data-name": "Tracciato 72",
    d: "M651.957,55.416h2.32l3.557,8.462h.034l3.523-8.462h2.3V67.553h-2v-8.34h-.034l-3.574,8.34h-.508l-3.574-8.34h-.051v8.34h-2Z",
    transform: "translate(-651.195 -54.896)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_73",
    "data-name": "Tracciato 73",
    d: "M696.9,64.425h1.931v5.722c0,1.37.457,1.838,1.575,1.838a1.723,1.723,0,0,0,1.846-1.977V64.425h1.931v9.19H702.32V72.73h-.034a2.761,2.761,0,0,1-2.32,1.144c-2.1,0-3.065-1.353-3.065-3.5Z",
    transform: "translate(-681.776 -60.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_74",
    "data-name": "Tracciato 74",
    d: "M727.282,69.577a2.06,2.06,0,0,0,2.168,2.1c1.219,0,1.9-.468,1.9-1.179,0-.728-.559-.9-2.473-1.456-2.032-.589-3.015-1.3-3.015-2.687s1.152-2.722,3.3-2.722a3.448,3.448,0,0,1,3.675,2.687l-1.626.486a1.955,1.955,0,0,0-2.05-1.526c-1.016,0-1.541.486-1.541.989,0,.607.373.763,2.642,1.422s2.828,1.509,2.828,2.844c0,1.283-1.033,2.809-3.573,2.809a3.689,3.689,0,0,1-4-3.329Z",
    transform: "translate(-701.248 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_75",
    "data-name": "Tracciato 75",
    d: "M761.13,71.19a4.149,4.149,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.778-4.855,4.132-4.855c2.337,0,4.082,1.838,4.082,4.855v.59h-6.266c.051,1.491.813,2.514,2.235,2.514a2.7,2.7,0,0,0,2.371-1.56Zm-1.609-3.607a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-720.073 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_76",
    "data-name": "Tracciato 76",
    d: "M783.131,68.485c0-3.138,1.948-4.855,4.166-4.855,2.2,0,4.133,1.717,4.133,4.855s-1.812,4.855-4.133,4.855C784.96,73.34,783.131,71.623,783.131,68.485Zm6.4,0c0-1.994-.932-3.069-2.236-3.069s-2.252,1.04-2.252,3.069c0,2.046.932,3.069,2.252,3.069C788.6,71.554,789.533,70.479,789.533,68.485Z",
    transform: "translate(-740.447 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_77",
    "data-name": "Tracciato 77",
    d: "M828.446,63.89h1.863v.884h.034a3.144,3.144,0,0,1,2.422-1.144c1.965,0,3.2,1.266,3.2,3.433V73.08h-1.914v-5.5c0-1.353-.475-2.133-1.745-2.133a1.8,1.8,0,0,0-1.931,1.924v5.7h-1.931Z",
    transform: "translate(-771.28 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_78",
    "data-name": "Tracciato 78",
    d: "M863.549,72.161h-.034a2.9,2.9,0,0,1-2.54,1.179c-2.235,0-3.167-1.3-3.167-2.687,0-1.613.88-2.324,3.048-2.861,1.948-.5,2.4-.711,2.4-1.37,0-.589-.491-1.092-1.643-1.092a1.858,1.858,0,0,0-2,1.612l-1.643-.642a3.43,3.43,0,0,1,3.591-2.67c2,0,3.624.971,3.624,3.5V73.08h-1.642Zm-3.879-1.647c0,.746.508,1.11,1.473,1.11,1.541,0,2.185-.763,2.185-1.543V68.242H863.3c-.1.225-.271.468-2.049.954C859.874,69.542,859.671,70.011,859.671,70.514Z",
    transform: "translate(-791.258 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_79",
    "data-name": "Tracciato 79",
    d: "M886.744,71.985l5.064-5.7v-.035h-4.827V64.425h7.3v1.6L889.3,71.69v.035h5.1v1.89h-7.655Z",
    transform: "translate(-810.947 -60.957)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_80",
    "data-name": "Tracciato 80",
    d: "M917.06,53.826h2v1.959h-2Zm.034,3.468h1.931v9.19h-1.931Z",
    transform: "translate(-831.574 -53.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_81",
    "data-name": "Tracciato 81",
    d: "M929.409,68.485c0-3.138,1.947-4.855,4.166-4.855,2.2,0,4.132,1.717,4.132,4.855s-1.812,4.855-4.132,4.855C931.238,73.34,929.409,71.623,929.409,68.485Zm6.4,0c0-1.994-.932-3.069-2.235-3.069s-2.253,1.04-2.253,3.069c0,2.046.931,3.069,2.253,3.069C934.879,71.554,935.811,70.479,935.811,68.485Z",
    transform: "translate(-839.977 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_82",
    "data-name": "Tracciato 82",
    d: "M961.473,63.89h1.863v.884h.034a3.143,3.143,0,0,1,2.422-1.144c1.964,0,3.2,1.266,3.2,3.433V73.08h-1.914v-5.5c0-1.353-.474-2.133-1.745-2.133a1.8,1.8,0,0,0-1.931,1.924v5.7h-1.931Z",
    transform: "translate(-861.793 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_83",
    "data-name": "Tracciato 83",
    d: "M996.576,72.161h-.034A2.9,2.9,0,0,1,994,73.34c-2.235,0-3.167-1.3-3.167-2.687,0-1.613.88-2.324,3.048-2.861,1.948-.5,2.405-.711,2.405-1.37,0-.589-.491-1.092-1.643-1.092a1.859,1.859,0,0,0-2,1.612L991,66.3a3.429,3.429,0,0,1,3.591-2.67c2,0,3.624.971,3.624,3.5V73.08h-1.643ZM992.7,70.514c0,.746.508,1.11,1.474,1.11,1.541,0,2.185-.763,2.185-1.543V68.242h-.034c-.1.225-.271.468-2.049.954C992.9,69.542,992.7,70.011,992.7,70.514Z",
    transform: "translate(-881.772 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_84",
    "data-name": "Tracciato 84",
    d: "M1021.362,53.826h2V66.483h-2Z",
    transform: "translate(-902.543 -53.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_85",
    "data-name": "Tracciato 85",
    d: "M1041.653,71.19a4.15,4.15,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.779-4.855,4.132-4.855c2.337,0,4.081,1.838,4.081,4.855v.59h-6.266c.051,1.491.813,2.514,2.236,2.514a2.7,2.7,0,0,0,2.371-1.56Zm-1.609-3.607a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-910.944 -60.422)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_86",
    "data-name": "Tracciato 86",
    d: "M655.958,121.6h-.034a3.09,3.09,0,0,1-2.456,1.145c-2.371,0-3.9-1.907-3.9-4.855,0-3.087,1.863-4.855,3.878-4.855a2.869,2.869,0,0,1,2.338,1.144h.034v-4.352h1.931v12.657h-1.8Zm-.136-4.716a1.988,1.988,0,0,0-2.049-2.063c-1.44,0-2.269,1.057-2.269,3.069s.83,3.069,2.269,3.069a1.964,1.964,0,0,0,2.049-1.994Z",
    transform: "translate(-649.573 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_87",
    "data-name": "Tracciato 87",
    d: "M689.209,127.19a4.15,4.15,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.778-4.855,4.132-4.855c2.337,0,4.082,1.838,4.082,4.855v.589h-6.266c.051,1.491.813,2.514,2.236,2.514a2.694,2.694,0,0,0,2.371-1.561Zm-1.609-3.606a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-671.137 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_88",
    "data-name": "Tracciato 88",
    d: "M713.065,109.827h2v12.657h-2Z",
    transform: "translate(-692.774 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_89",
    "data-name": "Tracciato 89",
    d: "M727.268,109.827h2v12.657h-2Z",
    transform: "translate(-702.438 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_90",
    "data-name": "Tracciato 90",
    d: "M747.56,127.19a4.15,4.15,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.778-4.855,4.132-4.855c2.337,0,4.082,1.838,4.082,4.855v.589h-6.266c.051,1.491.813,2.514,2.236,2.514a2.694,2.694,0,0,0,2.371-1.561Zm-1.609-3.606a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-710.84 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_91",
    "data-name": "Tracciato 91",
    d: "M788.552,128.162h-.034a2.9,2.9,0,0,1-2.54,1.179c-2.236,0-3.167-1.3-3.167-2.687,0-1.613.88-2.324,3.048-2.861,1.948-.5,2.4-.711,2.4-1.37,0-.59-.491-1.092-1.643-1.092a1.859,1.859,0,0,0-2,1.613l-1.643-.642a3.43,3.43,0,0,1,3.591-2.67c2,0,3.624.971,3.624,3.5v5.947h-1.642Zm-3.879-1.647c0,.745.508,1.109,1.473,1.109,1.542,0,2.185-.763,2.185-1.543v-1.838H788.3c-.1.225-.271.468-2.049.954C784.877,125.543,784.674,126.012,784.674,126.515Z",
    transform: "translate(-740.23 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_92",
    "data-name": "Tracciato 92",
    d: "M813.337,120.069h1.829v.971h.034a2.1,2.1,0,0,1,1.863-1.144,2.019,2.019,0,0,1,.8.173l-.3,1.924a2.361,2.361,0,0,0-.711-.138c-1.016,0-1.575.693-1.575,2.289v5.115h-1.931Z",
    transform: "translate(-761 -98.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_93",
    "data-name": "Tracciato 93",
    d: "M831.492,117.49h-1.355v-1.7h1.406v-2.254h1.829v2.254h2.252v1.7h-2.235V121.7c0,.953.186,1.37,1.169,1.37h.711v1.907h-.864c-2.253,0-2.913-1.04-2.913-3.069Z",
    transform: "translate(-772.431 -94.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_94",
    "data-name": "Tracciato 94",
    d: "M853.139,109.827h2v1.959h-2Zm.034,3.468H855.1v9.19h-1.931Z",
    transform: "translate(-788.082 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_95",
    "data-name": "Tracciato 95",
    d: "M885.123,121.6h-.034a3.09,3.09,0,0,1-2.456,1.145c-2.371,0-3.9-1.907-3.9-4.855,0-3.087,1.863-4.855,3.878-4.855a2.868,2.868,0,0,1,2.337,1.144h.034v-4.352h1.931v12.657h-1.8Zm-.135-4.716a1.988,1.988,0,0,0-2.05-2.063c-1.439,0-2.269,1.057-2.269,3.069s.83,3.069,2.269,3.069a1.964,1.964,0,0,0,2.05-1.994Z",
    transform: "translate(-805.5 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_96",
    "data-name": "Tracciato 96",
    d: "M918.374,127.19a4.151,4.151,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.778-4.855,4.132-4.855c2.337,0,4.081,1.838,4.081,4.855v.589h-6.266c.051,1.491.813,2.514,2.236,2.514a2.694,2.694,0,0,0,2.371-1.561Zm-1.609-3.606a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-827.064 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_97",
    "data-name": "Tracciato 97",
    d: "M942.23,109.827h2v12.657h-2Z",
    transform: "translate(-848.7 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_98",
    "data-name": "Tracciato 98",
    d: "M970.2,117.087l-3.252-5.67h2.269l2.3,4.386h.051l2.27-4.386h2.2l-3.387,6.016,3.523,6.121H973.9l-2.574-4.838H971.3l-2.591,4.838h-2.2Z",
    transform: "translate(-865.216 -92.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_99",
    "data-name": "Tracciato 99",
    d: "M1002.048,117.087l-3.252-5.67h2.269l2.3,4.386h.051l2.269-4.386h2.2l-3.388,6.016,3.523,6.121h-2.27l-2.574-4.838h-.034l-2.591,4.838h-2.2Z",
    transform: "translate(-886.889 -92.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_100",
    "data-name": "Tracciato 100",
    d: "M1034.183,111.417h2v12.137h-2Z",
    transform: "translate(-911.266 -92.574)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_101",
    "data-name": "Tracciato 101",
    d: "M1062.073,125.578a2.061,2.061,0,0,0,2.168,2.1c1.219,0,1.9-.468,1.9-1.179,0-.728-.559-.9-2.473-1.456-2.032-.59-3.015-1.3-3.015-2.687s1.152-2.722,3.3-2.722a3.448,3.448,0,0,1,3.675,2.687L1066,122.8a1.955,1.955,0,0,0-2.05-1.526c-1.016,0-1.541.486-1.541.988,0,.607.373.763,2.642,1.422s2.828,1.509,2.828,2.844c0,1.283-1.033,2.809-3.573,2.809a3.689,3.689,0,0,1-4-3.329Z",
    transform: "translate(-929.044 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_102",
    "data-name": "Tracciato 102",
    d: "M1095.921,127.19a4.149,4.149,0,0,1-3.726,2.15c-2.439,0-4.217-1.873-4.217-4.855s1.778-4.855,4.132-4.855c2.337,0,4.081,1.838,4.081,4.855v.589h-6.266c.051,1.491.813,2.514,2.235,2.514a2.694,2.694,0,0,0,2.371-1.561Zm-1.609-3.606a2.1,2.1,0,0,0-2.2-2.2,2.2,2.2,0,0,0-2.168,2.2Z",
    transform: "translate(-947.869 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_103",
    "data-name": "Tracciato 103",
    d: "M1125.882,125.838c-.355,2.168-1.642,3.5-3.793,3.5-2.354,0-4.166-1.717-4.166-4.855,0-3.017,1.829-4.855,4.15-4.855a3.615,3.615,0,0,1,3.709,3.4l-1.812.312c-.152-1.04-.677-1.924-1.88-1.924-1.355,0-2.252,1.092-2.252,3.069,0,1.924.813,3.069,2.252,3.069,1.2,0,1.711-.954,1.88-2.133Z",
    transform: "translate(-968.243 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_104",
    "data-name": "Tracciato 104",
    d: "M1146.807,124.486c0-3.138,1.948-4.855,4.166-4.855,2.2,0,4.133,1.717,4.133,4.855s-1.812,4.855-4.133,4.855C1148.636,129.341,1146.807,127.624,1146.807,124.486Zm6.4,0c0-1.994-.932-3.069-2.236-3.069s-2.253,1.04-2.253,3.069c0,2.046.931,3.069,2.253,3.069C1152.277,127.555,1153.209,126.48,1153.209,124.486Z",
    transform: "translate(-987.897 -98.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_105",
    "data-name": "Tracciato 105",
    d: "M1178.871,109.827h2v12.657h-2Z",
    transform: "translate(-1009.713 -91.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_106",
    "data-name": "Tracciato 106",
    d: "M1191.22,124.486c0-3.138,1.948-4.855,4.166-4.855,2.2,0,4.133,1.717,4.133,4.855s-1.812,4.855-4.133,4.855C1193.049,129.341,1191.22,127.624,1191.22,124.486Zm6.4,0c0-1.994-.931-3.069-2.236-3.069s-2.252,1.04-2.252,3.069c0,2.046.931,3.069,2.252,3.069C1196.69,127.555,1197.622,126.48,1197.622,124.486Z",
    transform: "translate(-1018.116 -98.101)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMaxxiFull);
export default __webpack_public_path__ + "static/media/logo_maxxi_full.a760fd6eced55ce1655e42467a80a9ef.svg";
export { ForwardRef as ReactComponent };